import React from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "./LanguageSwitcher";
import FormButton from "../form/FormButton";
import useModalStore from "../../store/useModalStore";
import useApplyStore from "../../store/useApplyStore";
import useViewStore from "../../store/useViewStore";
import { basename } from "../../setting";

const NavigationBarClean = ({ hideCloseBtn = false }) => {
  const { t } = useTranslation();
  const { openModalConfirm } = useModalStore();
  const { resetStep } = useApplyStore();
  const { isPadView, isMobileView } = useViewStore((state) => state);
  const navigate = useNavigate();

  const isProgressPage = window.location.pathname === `/${basename}/${i18n.language}/apply/progress`;

  return (
    <Header $isMobileView={isMobileView}>
      <HeaderLeft>
        <IconMobile src={`${process.env.PUBLIC_URL}/images/icon.png`} alt="Blue Cross Logo" />
        <SiteTitle>{t("term.preAuth")}</SiteTitle>
      </HeaderLeft>
      <HeaderRight>
        <LanguageSwitcher />

        {
          !hideCloseBtn && <FormButton onClick={() => {
            if (isProgressPage) {
              navigate(`${process.env.PUBLIC_URL}/${i18n.language}`);
              return;
            }

            openModalConfirm({
              title: t("translation:apply.nav.exitTitle"),
              text: t("translation:apply.nav.exitContent"),
              callback: () => {
                resetStep();
                navigate(`${process.env.PUBLIC_URL}/${i18n.language}`, { replace: true });
              }
            });
          }}>
            <CloseImg src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" />
          </FormButton>
        }

      </HeaderRight>
    </Header>
  );
}

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  background-color: var(--aia-bx-white);
  display: flex;
  ${props => props.$isMobileView ? `padding: 0 8px 0 0;` : `padding: 0 16px;`}
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 5rem;
  z-index: 500;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 1 auto;
`;

const SiteTitle = styled.div`
  color: var(--aia-bx-dark-blue);
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
`;

const Icon = styled.img`
  width: 226px;
  height: 48px;
`;

const IconMobile = styled.img`
  padding: 15px;
  aspect-ratio: 1;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  justify-content: flex-end;
`;

const CloseImg = styled.img`
  width: 30px;
  height: 30px;
`

export default NavigationBarClean;